import React from 'react';
import { Flex, Tag, TagLabel } from '@stockx/ui';
import { XpressShippingIcon } from '@drc/pages/Product/shared/components/XpressShipping';
import { useTranslation } from 'react-i18next';

const XpressShippingFooter = () => {
  const { t } = useTranslation();
  return (
    <Flex mt="1">
      <Tag>
        <TagLabel>
          <XpressShippingIcon boxSize="5" />
        </TagLabel>
        <TagLabel>{t('Xpress Ship')}</TagLabel>
      </Tag>
    </Flex>
  );
};

export default XpressShippingFooter;
